
import $ from "jquery";
import DataTable from "datatables.net-bs5";
import jszip from 'jszip'; // For Excel export
import 'datatables.net-buttons-bs5';
import 'datatables.net-buttons/js/buttons.html5';
import {initPopper} from "@/modules/popper";
import {clearGeoJsonLayers, createGeoJsonLayer, toggleGeoJsonLayer} from "@/helpers/ol/ol-geo-json-helper";
import toastr from "toastr"
import {loadLinkedData} from "@/helpers/layer/info/layer-info-info-linked-data-helper";
import {Polygon} from "ol/geom";
import {inflateCoordinatesArray} from "ol/geom/flat/inflate";
import {addServiceWmsByUrl} from "@/modules/ol/service/ol-service-wms.js";
import {getLayerByName, refreshAllActiveLayers} from "@/helpers/ol/ol-layer-helper.js";
import {initDataTablePlugin} from "@/helpers/datatable/datatable-plugin-helper.js";
import "datatables.net-buttons/js/buttons.print"
import {initHideButton} from "@/helpers/layer/info/layer-info-helper.js";
import {initLanguage} from "@/modules/language/language.js";
import {clearWordPrint} from "@/helpers/word/word-helper.js";
import {deselectFeature} from "@/modules/ol/service/ol-service-wfs.js";
import {removeInfoMvt} from "@/modules/ol/service/ol-service-mvt.js";
import {removeCycloramaPlugin} from "@/helpers/ol/ol-plugin-helper.js";
import {disableMoveLayer} from "@/helpers/ol/map/ol-move-helper.js";
import DOMPurify from "dompurify";
import {getBySelector} from "@/helpers/element-helper.js";
import sw from "datatables.net-plugins/i18n/sw.mjs";

// DataTable.Buttons.jszip(JSZip);
window.JSZip = jszip;
let table


export function initDataTable(dataTable, name = null) {

    name = getDataTableName(dataTable, name)

    table = new DataTable('#' + name, getDataTableOptions(dataTable, name));

    if(dataTable.featureInfo.ShowMultipleRecordsInTable) {
        window.ShowMultipleRecordsInTable = table
    }

    table.on('select', function (e, dt, type, indexes) {
        const rowData = dt.rows(indexes).data().toArray();

        if(dataTable.featureInfo.PluginFormType === 25) {
            initDataTablePlugin(rowData[0], true, dataTable.featureInfo.records[0].attributes[0][0].ActionAdvanced)
            return
        }

        if (dataTable.featureInfo.IsShowMoreInfoVisible || dataTable.featureInfo.ShowMultipleRecordsInTable) {


            let featureID
            if(rowData[0] && rowData[0][0]) {
                featureID = rowData[0][0]
            }

            if(featureID === undefined) {
                featureID = rowData[0].featureid
            }

            if(dataTable.featureInfo.LayerName === 'zakelijkGerechtigden') {
                featureID = dataTable.feature.id + '/' + featureID;

                // featureID = featureID.replace('bijbehorendeAppartementsrechten.bag:', '')
                // featureID = featureID.replace('kadastraalonroerendezaken.bag:', '')
            }


            indexes.map((index) => {
                setTimeout(() => {
                    if(dataTable.featureInfo.ShowMultipleRecordsInTable) {
                        deselectFeature(true)
                        table.rows().eq(0).each(index  => {
                            toggleGeoJsonLayer(dataTable.FormID, index, false)
                        });
                    }
                    toggleGeoJsonLayer(dataTable.FormID, index, true)
                }, 300)

                loadLinkedData(dataTable.DomainID, dataTable.PresentationID, featureID, dataTable.index)
            })
        } else {
            toastr.warning('Doorklikken niet mogelijk')
        }
    }).on('deselect', function (e, dt, type, indexes) {
        const rowData = dt.rows(indexes).data().toArray();
        if(dataTable.featureInfo.PluginFormType === 25) {
            initDataTablePlugin(rowData[0], false)
        }
    }).on('mouseleave', 'tbody tr', function () {

        if(dataTable.featureInfo.ShowMultipleRecordsInTable) {

            // If mark is check then visible is true
            const switcher = getBySelector('#' + name).closest('.card').querySelector('.switcher input')
            let visible = true
            if(switcher && !switcher.checked) {
                visible = false
            }

            table.rows().eq(0).each(index  => {
                toggleGeoJsonLayer(dataTable.FormID, index, visible)
            });
        } else {
            const index = new DataTable('#' + name).row(this).index();
            toggleGeoJsonLayer(dataTable.FormID, index, false)
        }


    }).on('mouseenter', 'tbody tr', function () {
        const index = new DataTable('#' + name).row(this).index();
        const data = new DataTable('#' + name).row(this).data();

        if(window.mvtFeatures) {
            const mvtFeature = window.mvtFeatures.find(feature => feature.getProperties()['objectid'] === data.identificatie)
            if (mvtFeature && !mvtFeature.loaded) {
                mvtFeature.loaded = true
                const feature = {}

                const inflatedCoordinates = inflateCoordinatesArray(
                    mvtFeature.getFlatCoordinates(), // flat coordinates
                    0, // offset
                    mvtFeature.getEnds(), // geometry end indices
                    2, // stride
                )

                feature.geometry = {}
                feature.geometry.type = mvtFeature.getType()
                feature.geometry.coordinates = inflatedCoordinates
                feature.projection = 'EPSG:28992'

                createGeoJsonLayer(feature, dataTable.FormID + '-' + index, true)
            } else {
                toggleGeoJsonLayer(dataTable.FormID, index, true)
            }
        } else {

            if(dataTable.featureInfo.ShowMultipleRecordsInTable) {
                table.rows().eq(0).each(index  => {
                    toggleGeoJsonLayer(dataTable.FormID, index, false)
                });
                toggleGeoJsonLayer(dataTable.FormID, index, true)
            } else {
                toggleGeoJsonLayer(dataTable.FormID, index, true)
            }
        }


    });

    let resizeText = '<span class="fa fa-chevron-down"></span><div class="popper-tooltip" role="tooltip" data-popper-placement="top">Vergroten<div class="arrow" data-popper-arrow=""></div></div>'
    if(dataTable.IsCollapsedDefault) {
        resizeText = '<span class="fa fa-chevron-up"></span><div class="popper-tooltip" role="tooltip" data-popper-placement="top">Verkleinen<div class="arrow" data-popper-arrow=""></div></div>'
    }

    const buttons = [
        {
            extend: "csv",
            text: '<span class="fa fa-file-csv"></span><div class="popper-tooltip" role="tooltip" data-popper-placement="top">Download csv<div class="arrow" data-popper-arrow=""></div></div>',
            className: 'btn-sm btn-outline-secondary icon-btn popper-header'
        },
        {
            extend: "excel",
            text: '<span class="fa fa-file-excel"></span><div class="popper-tooltip" role="tooltip" data-popper-placement="top">Download excel<div class="arrow" data-popper-arrow=""></div></div>',
            className: 'btn-sm btn-outline-secondary icon-btn popper-header'
        },
        {
            extend: "print",
            text: '<span class="fa fa-print"></span><div class="popper-tooltip" role="tooltip" data-popper-placement="top">Printen<div class="arrow" data-popper-arrow=""></div></div>',
            className: 'btn-sm btn-outline-secondary icon-btn popper-header'
        }
    ]

    if(dataTable.scrollY === undefined) {
        buttons.push({
            text: resizeText,
            className: 'btn-sm btn-outline-secondary icon-btn popper-header ml-2',
            titleAttr: 'Vergroten',
            action: function (e, dt, node, config) {
                const element = $('#' + name + '_wrapper').find('.dataTables_scrollBody');
                if (element.css('max-height') === 'none') {
                    element.css('max-height', '300px');
                    $(e.currentTarget).find('.fa').removeClass('fa-chevron-up').addClass('fa-chevron-down');
                    $(e.currentTarget).find('.popper-tooltip').html('Vergroten');
                } else {
                    element.css('max-height', 'unset');
                    $(e.currentTarget).find('.fa').removeClass('fa-chevron-down').addClass('fa-chevron-up');
                    $(e.currentTarget).find('.popper-tooltip').html('Verkleinen');
                }
            }
        })
    }

    // Display the buttons
    new $.fn.dataTable.Buttons( table, buttons);

    table.buttons().container().appendTo( $('.col-md-6:eq(1)', table.table().container() ) );

    initPopper()

    return table
}

export function getDataTableOptions(dataTable, name) {

    // console.log(dataTable)

    const columnDefs = [
        {
            target: 0,
            visible: false,
            searchable: false,
        },
        {
            targets: '_all', // Apply to all columns
            createdCell: function (td, cellData, rowData, row, col) {
                // Sanitize only for strings (avoid breaking numbers, dates, etc.)
                if (typeof cellData === 'string') {
                    td.innerHTML = DOMPurify.sanitize(cellData);
                }
            }
        }
    ]

    if(dataTable.hiddenColumns && dataTable.featureInfo.ShowEmptyFormAttributes === 0) {
        dataTable.hiddenColumns.map((item) => {
            columnDefs.push({
                target: item.key + 1,
                visible: false,
                searchable: false,
            })
        })
    }
    let scrollY = '300px'
    if(dataTable.scrollY !== undefined) {
        scrollY = dataTable.scrollY
    }

    if(dataTable.IsCollapsedDefault) {
        scrollY = 'calc(100vh - 430px)'
    }

    let selector = ''
    if(dataTable.featureInfo && dataTable.featureInfo.records.length > 0) {
        selector = []
        dataTable.featureInfo.records[0].attributes.map((column, key) => {
            if(column[0].Type !== 1) {

                key = parseInt(key) + 1

                selector.push('tr>td:nth-child(' + key + ')')
            }
        })
        selector = selector.join(',')
    }

    let select =  {
        style: 'single',
        selector: selector
    }
    if(dataTable.featureInfo.PluginFormType === 25) {
        select = {
            style: 'multi',
            selector: 'tr>td:nth-child(2)'
        }
    }

    const options = {

        deferRender:    true,
        destroy:        true,
        scrollY:        scrollY,
        scrollCollapse: true,
        scroller:       false,
        autoWidth:      false,
        scrollX:        true,
        paging:         false,
        fixedColumns:   true,
        searching:      false,
        columnDefs: columnDefs,
        responsive: true,
        select: select,
        initComplete: function() {
            const element = document.getElementById(name + '_info')
            if(element) {
                element.parentNode.classList.remove('col-md-5')
            }
        },
        language: {
            "sProcessing": "",
            "sLengthMenu": "_MENU_ resultaten weergeven",
            "sZeroRecords": "Geen resultaten gevonden",
            "sInfo": "_START_ tot _END_ van _TOTAL_ resultaten",
            // "sInfo": "Er zijn _TOTAL_ resultaten",
            "sInfoEmpty": "Geen resultaten om weer te geven",
            "sInfoFiltered": " (gefilterd uit _MAX_ resultaten)",
            "sInfoPostFix": "",
            "sSearch": "Zoeken:",
            "sEmptyTable": "Geen resultaten aanwezig in de tabel",
            "sInfoThousands": ".",
            "sLoadingRecords": "Een moment geduld aub - bezig met laden...",
            "oPaginate": {
                "sFirst": "Eerste",
                "sLast": "Laatste",
                "sNext": "Volgende",
                "sPrevious": "Vorige"
            },
            "oAria": {
                "sSortAscending": ": activeer om kolom oplopend te sorteren",
                "sSortDescending": ": activeer om kolom aflopend te sorteren"
            },
            select: {
                rows: {
                    _: "%d items geselecteerd",
                    0: "Klik op een item om het te selecteren",
                    1: "1 item geselecteerd"
                }
            }
        }
    }

    options.order = dataTable.Order

    if(dataTable.columns) {
        options.columns = dataTable.columns
    }
    return options
}

export function resizeDataTable() {
    if(window.dataTables) {
        window.dataTables.map((dataTable) => {
            $('#' + dataTable.Name).DataTable().columns.adjust()
        })
    }
}

export function getDataTableName(dataTable, name = null) {

    if(name === null) {
        name = 'dataTable-feature-' + dataTable.FeatureIndex + '-info-' + dataTable.FeatureInfoIndex + '-form-' + dataTable.FormID
    }
    return name
}
